import { LoadingButton } from '@mui/lab';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { showErrorNotification, showSuccessNotification } from '../../../components/admin/common/NotiService'; // Assuming this is the correct path
import { fwpSync } from '../../../services/api-service'; // Assuming this is the correct path
import { ReactComponent as SmartPhone } from '../../../static/icons/smartPhone.svg';
import { checkRoles } from '../../../utils/util';
import { FWP_SYNC_ACCESS_USERS } from '../../../utils/properties';
import { getUserName } from '../../../services/auth-service';

export default function FwpSync() {
    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const isOzonetelAccount = useMemo(() => {
        try {
            return (FWP_SYNC_ACCESS_USERS.map(user => user.toLowerCase().trim()).includes(getUserName()?.toLowerCase()?.trim()));
        } catch (error) {
            console.error("Error fetching user name", error);
            return false;
        }
    }, []);

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmSync = async () => {
        try {
            setLoading(true);
            const response = await fwpSync();
            if (response === "success") {
                showSuccessNotification("FWP Sync initiated successfully.");
            } else {
                showErrorNotification("FWP Sync failed. Please try again.");
            }
        } catch (error) {
            console.error("FWP Sync failed", error);
            showErrorNotification("FWP Sync failed. Please try again.");
        } finally {
            handleCloseDialog();
            setLoading(false);
        }
    };


    return (checkRoles("ROLE_ADMIN") && isOzonetelAccount) ? (
        <>
            <Box sx={{
                display: 'flex', width: '757px', background: 'white', borderRadius: '8px', justifyItems: 'center', alignContent: 'space-between', mt: '25px'
            }}>
                <Typography className='admin-settings-text-font' flexGrow={1} fontSize="14px">
                    FWP Sync
                </Typography>
                <IconButton
                    onClick={handleOpenDialog}
                    sx={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        mt: "5px",
                        mr: 2
                    }}
                >
                    <SmartPhone />
                </IconButton>
            </Box>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="fwp-sync-dialog-title"
                aria-describedby="fwp-sync-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: "8px",
                        width: "400px"
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: "18px", fontWeight: "400", color: "#212121" }} id="fwp-sync-dialog-title">Confirm FWP Sync</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontSize: "14px", fontWeight: "400", color: "#212121" }} id="fwp-sync-dialog-description">
                        This will Sync the FWP Number details from Central to Local DB.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ gap: "16px" }}>
                    <Button onClick={handleCloseDialog} color="primary" variant='outlined' sx={{ borderRadius: "8px" }}>
                        Cancel
                    </Button>
                    <LoadingButton sx={{ borderRadius: "8px" }} loading={loading} onClick={handleConfirmSync} color="primary" autoFocus variant='contained'>
                        Continue
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    ) : null
}
